import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { staticURL } from 'core/url';

import { media } from 'legacyComponents/styled/styleUtils';
import { ButtonGroup } from 'legacyComponents/styles';
import { CardIndicator } from 'legacyComponents/cards/types/indicator';
import { PostCard } from 'legacyComponents/cards/styles';
import { Heading, OverflowTooltip, Paragraph } from 'components';

export const brandIcons = {
  Visa: 'visa.svg',
  MasterCard: 'mastercard.svg',
  'American Express': 'amex.svg',
  UnionPay: 'unionpay.svg',
  'Diners Club': 'diners.svg',
  Discover: 'discover.svg',
  JCB: 'jcb.svg',
  Unknown: 'default.svg',
};

export const CreditCard = withNamespaces()(
  observer(({ cardObject, cardNo, cardColumns, leftNode, children }) => {
    const noMargin = (cardNo + 1) % cardColumns === 0;
    if (cardObject === null) {
      return <CardIndicator noMargin={noMargin} type='issue' />;
    }
    const { brand, name, lastDigits, expMonth, expYear } = cardObject;

    return (
      <Card style={{ overflowX: 'scroll' }} className='flex'>
        <div className='flex items-center justify-around min-w-fit'>
          {leftNode}
          <CardLogo
            src={staticURL(`/assets/creditCards/flat/${brandIcons[brand]}`)}
          />
          <Paragraph
            style={{ margin: '0px auto' }}
            className='flex flex-nowrap'
          >
            <Heading
              level={5}
              style={{ marginRight: 16 }}
              data-testid={`creditCardSection-cardHolderName-${name}-text`}
            >
              {<OverflowTooltip text={name} />}
            </Heading>
            <strong
              className='whitespace-no-wrap min-w-fit'
              data-testid={`creditCardSection-cardNumber-${name}-text`}
            >
              **** **** **** {lastDigits}
            </strong>{' '}
            &nbsp;&nbsp; &mdash; &nbsp;&nbsp;Exp:{' '}
            <strong
              className='whitespace-no-wrap min-w-fit'
              data-testid={`creditCardSection-cardExpDate-${name}-text`}
            >
              {expMonth}/{expYear} &nbsp;&nbsp;
            </strong>
          </Paragraph>
        </div>
        {children && <ButtonGroup>{children}</ButtonGroup>}
      </Card>
    );
  }),
);

const Card = styled(PostCard)`
  padding: 16px;
  display: flex;
  justify-content: space-between;
`;

export const CardLogo = styled.img`
  height: 30px;
  width: auto;
  margin-right: 16px;
  display: inline-block;
  vertical-align: top;
  opacity: ${props => (props.mono ? '0.4' : '1')};
  ${media.xs`
    height: ${props => (props.mono ? '20px' : '30px')};
  `};
`;

const TextWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  > h5 {
    margin: 0 0 8px;
  }
  > p {
    font-size: 0.9em;
  }
`;

export const DeleteButton = styled.button`
  background-color: transparent;
  border: none;
  text-decoration: underline;
  font-size: 0.8em;
  cursor: pointer;
  color: ${props => props.theme.color.wfGrey500};
  &:hover {
    color: ${props => props.theme.color.wfOrange};
  }
`;

CreditCard.propTypes = {
  cardObject: PropTypes.object,
  cardNo: PropTypes.number,
};
